import React, { useState } from 'react';
import './SchemeSearch.css';

/* ============================================================
   NAV DATA
   ============================================================ */
const MAIN_NAV = [
  { label: 'Search Schools', href: '' },
  { label: 'Search Schemes', href: '' },
  { label: 'Prayas', href: '' },
  { label: 'NAS Question Bank', href: '' },
  { label: 'Board Exam Question Bank', href: '' },
  { label: 'Suggestions from citizen', href: '' },
];

const REPORT_LINKS = [
  { label: 'School', href: '' },
  { label: 'Student', href: '' },
  { label: 'Staff', href: '' },
];

const CLASS_OPTIONS = Array.from({ length: 12 }, (_, i) => i + 1);
const CAST_OPTIONS = ['GEN', 'ST', 'SC', 'SBC', 'OBC'];

/* ============================================================
   MAIN COMPONENT
   ============================================================ */
export default  function SearchSchemes() {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  // Form state
  const [form, setForm] = useState({
    gender: 'A',
    minority: '0',
    bplcard: '0',
    age: '',
    cls: '0',
    cast: '1',
    income: '',
    captcha: '',
  });

  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);

  /* -------- handlers -------- */
  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
    setErrors((prev) => ({ ...prev, [field]: '' }));
  };

  const onlyNumbers = (e) => {
    const charCode = e.which ? e.which : e.keyCode;
    if (charCode < 48 || charCode > 57) e.preventStudent_school_darpan();
  };

  const validate = () => {
    const errs = {};
    if (!form.gender) errs.gender = 'Please Select Gender';
    if (!form.cls || form.cls === '0') errs.cls = 'Please Select Class';
    if (!form.income) errs.income = 'Please Enter Family Income';
    if (!form.captcha) errs.captcha = 'Please Enter Captcha';
    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventStudent_school_darpan();
    if (validate()) {
      setSubmitted(true);
      // Yahan API call / navigation kar sakte ho
      console.log('Form submitted:', form);
    }
  };

  const reloadCaptcha = () => {
    // Captcha refresh logic (dummy)
    console.log('Captcha reloaded');
  };

  return (
    <div className="ss-app">

    
   

   

      {mobileNavOpen && (
        <div className="mobile-nav-overly" onClick={() => setMobileNavOpen(false)} />
      )}

      {/* ============= MAIN FORM ============= */}
      <section className="ss-main">
        <div className="container">

          {/* Breadcrumb */}
          <ol className="breadcrumb breadcrumb-arrow">
            {/* <li>
              <a href="">Citizen Window</a>
            </li>
            <li className="active">
              <a href="">Search Schemes</a>
            </li> */}
          </ol>

          <div className="contentArea text-left">
            <h1 className="text-center">Search Schemes</h1>

            <form onSubmit={handleSubmit} className="scheme-form" noValidate>

              {/* Row 1 — Gender / Minority / BPL */}
              <div className="form-row three-col">

                <div className="form-group">
                  <label className="control-label">
                    Gender <span className="req">*</span>
                  </label>
                  <div className="radio-row">
                    <label className="radio-item">
                      <input
                        type="radio"
                        name="gender"
                        value="A"
                        checked={form.gender === 'A'}
                        onChange={() => handleChange('gender', 'A')}
                      />
                      <span>Boy</span>
                    </label>
                    <label className="radio-item">
                      <input
                        type="radio"
                        name="gender"
                        value="F"
                        checked={form.gender === 'F'}
                        onChange={() => handleChange('gender', 'F')}
                      />
                      <span>Girl</span>
                    </label>
                  </div>
                  {errors.gender && <span className="err-msg">{errors.gender}</span>}
                </div>

                <div className="form-group">
                  <label className="control-label">
                    Do you belong to minority
                  </label>
                  <div className="radio-row">
                    <label className="radio-item">
                      <input
                        type="radio"
                        name="minority"
                        value="0"
                        checked={form.minority === '0'}
                        onChange={() => handleChange('minority', '0')}
                      />
                      <span>No</span>
                    </label>
                    <label className="radio-item">
                      <input
                        type="radio"
                        name="minority"
                        value="1"
                        checked={form.minority === '1'}
                        onChange={() => handleChange('minority', '1')}
                      />
                      <span>Yes</span>
                    </label>
                  </div>
                </div>

                <div className="form-group">
                  <label className="control-label">
                    Do you have a BPL Card <span className="req">*</span>
                  </label>
                  <div className="radio-row">
                    <label className="radio-item">
                      <input
                        type="radio"
                        name="bplcard"
                        value="0"
                        checked={form.bplcard === '0'}
                        onChange={() => handleChange('bplcard', '0')}
                      />
                      <span>No</span>
                    </label>
                    <label className="radio-item">
                      <input
                        type="radio"
                        name="bplcard"
                        value="1"
                        checked={form.bplcard === '1'}
                        onChange={() => handleChange('bplcard', '1')}
                      />
                      <span>Yes</span>
                    </label>
                  </div>
                </div>

              </div>

              {/* Row 2 — Age / Class / Cast / Income */}
              <div className="form-row four-col">

                <div className="form-group">
                  <label className="control-label">Age</label>
                  <input
                    type="text"
                    maxLength={2}
                    className="form-control"
                    value={form.age}
                    onChange={(e) => handleChange('age', e.target.value)}
                    onKeyPress={onlyNumbers}
                    placeholder="Enter Age"
                  />
                </div>

                <div className="form-group">
                  <label className="control-label">
                    Class in which Studying <span className="req">*</span>
                  </label>
                  <select
                    className="form-control"
                    value={form.cls}
                    onChange={(e) => handleChange('cls', e.target.value)}
                  >
                    <option value="0">--Select Class--</option>
                    {CLASS_OPTIONS.map((c) => (
                      <option key={c} value={c}>{c}</option>
                    ))}
                  </select>
                  {errors.cls && <span className="err-msg">{errors.cls}</span>}
                </div>

                <div className="form-group">
                  <label className="control-label">Cast Category</label>
                  <select
                    className="form-control"
                    value={form.cast}
                    onChange={(e) => handleChange('cast', e.target.value)}
                  >
                    {CAST_OPTIONS.map((c, i) => (
                      <option key={c} value={i + 1}>{c}</option>
                    ))}
                  </select>
                </div>

                <div className="form-group">
                  <label className="control-label">
                    Family Income <span className="req">*</span>
                  </label>
                  <input
                    type="text"
                    maxLength={8}
                    className="form-control"
                    value={form.income}
                    onChange={(e) => handleChange('income', e.target.value)}
                    onKeyPress={onlyNumbers}
                    placeholder="Enter Income"
                  />
                  {errors.income && <span className="err-msg">{errors.income}</span>}
                </div>

              </div>

              {/* Row 3 — Captcha */}
              <div className="form-row captcha-row">

                <div className="form-group captcha-input">
                  <label className="control-label">Captcha Verification</label>
                  <input
                    type="text"
                    maxLength={6}
                    autoComplete="off"
                    className="form-control"
                    value={form.captcha}
                    onChange={(e) => handleChange('captcha', e.target.value)}
                    placeholder="Enter Result of Captcha Calculation"
                  />
                  {errors.captcha && <span className="err-msg">{errors.captcha}</span>}
                </div>

                <div className="form-group captcha-img-box">
                  {/* Captcha placeholder — inline SVG */}
                  <div className="captcha-visual">
                    <span>7 + 5 = ?</span>
                  </div>
                  <button
                    type="button"
                    className="captcha-refresh"
                    onClick={reloadCaptcha}
                    title="Refresh Captcha"
                  >
                    <i className="fa fa-refresh" />
                  </button>
                </div>

              </div>

              {/* Submit */}
              <div className="form-row submit-row">
                <button type="submit" className="form-button">
                  Search
                </button>
              </div>

              {submitted && (
                <p className="submit-success">✅ Form submitted successfully!</p>
              )}

            </form>
          </div>

        </div>
      </section>

      {/* ============= FOOTER ============= */}


    </div>
  );
}